(() => {
  'use strict';
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const body = document.body;
  const root = body.dataset.rootUrl || '/';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const lang = document.documentElement.lang === 'en' ? 'en' : 'de';
  const words = {
    de: { added: 'Zum Warenkorb hinzugefügt.', error: 'Das hat nicht geklappt. Bitte erneut versuchen.', empty: 'Dein Warenkorb ist noch leer.', subtotal: 'Zwischensumme', results: 'Produkte anzeigen', noSuggestions: 'Keine Vorschläge gefunden.' },
    en: { added: 'Added to cart.', error: 'Something went wrong. Please try again.', empty: 'Your cart is still empty.', subtotal: 'Subtotal', results: 'View products', noSuggestions: 'No suggestions found.' }
  }[lang];

  function toast(message) {
    const el = qs('#AzelaToast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('is-visible'), 3200);
  }

  // One observer and one scroll loop manage all editorial movement.
  const motion = (() => {
    const enabled = body.dataset.motion !== 'off' && !reduced.matches;
    const countUp = target => {
      const end = Number(target.dataset.counter);
      if (!Number.isFinite(end) || end < 1) return;
      const start = performance.now();
      const frame = now => {
        const progress = Math.min(1, (now - start) / 900);
        target.textContent = Math.round(end * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) requestAnimationFrame(frame);
      };
      requestAnimationFrame(frame);
    };
    const observer = enabled && 'IntersectionObserver' in window
      ? new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) { target.classList.add('is-visible'); if (target.dataset.counter) countUp(target); observer.unobserve(target); }
        }), { rootMargin: '0px 0px -6% 0px' })
      : null;
    const header = qs('[data-header]');
    const hero = qs('[data-hero]');
    const progress = qs('[data-reading-progress]');
    let lastY = window.scrollY;
    let queued = false;
    const tick = () => {
      queued = false;
      const y = window.scrollY;
      if (header) {
        if (Math.abs(y - lastY) > 6 && y > 180 && !body.classList.contains('menu-open') && !body.classList.contains('drawer-open')) {
          header.classList.toggle('is-hidden', y > lastY);
        } else if (y <= 180) header.classList.remove('is-hidden');
      }
      if (enabled && body.dataset.parallax === 'true' && hero && y < hero.offsetHeight) {
        hero.style.setProperty('--hero-shift', Math.min(45, y * 0.06) + 'px');
      }
      if (progress) {
        const distance = Math.max(1, document.documentElement.scrollHeight - innerHeight);
        progress.style.setProperty('--reading-progress', Math.min(100, y / distance * 100) + '%');
      }
      lastY = y;
    };
    const onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(tick); } };
    addEventListener('scroll', onScroll, { passive: true });
    tick();
    reduced.addEventListener?.('change', () => location.reload());
    return {
      refresh(scope = document) {
        qsa('[data-reveal],[data-counter],[data-split]', scope).forEach(el => {
          if (observer) observer.observe(el);
          else el.classList.add('is-visible');
        });
      }
    };
  })();
  motion.refresh();
  if (matchMedia('(hover:hover) and (pointer:fine)').matches && !reduced.matches && body.dataset.motion === 'editorial') {
    qsa('.button').forEach(button => {
      button.addEventListener('pointermove', event => {
        const box = button.getBoundingClientRect();
        button.style.translate = ((event.clientX - box.left - box.width / 2) * .06).toFixed(1) + 'px ' + ((event.clientY - box.top - box.height / 2) * .06).toFixed(1) + 'px';
      });
      button.addEventListener('pointerleave', () => { button.style.translate = '0 0'; });
    });
  }

  let previousFocus = null;
  const backdrop = qs('[data-drawer-backdrop]');
  const drawers = qsa('.utility-drawer');
  const closeDrawer = () => {
    drawers.forEach(el => { el.hidden = true; el.classList.remove('is-open'); });
    if (backdrop) backdrop.hidden = true;
    body.classList.remove('drawer-open');
    previousFocus?.focus?.();
  };
  const openDrawer = drawer => {
    if (!drawer) return;
    if (!body.classList.contains('drawer-open')) previousFocus = document.activeElement;
    drawers.forEach(el => { el.hidden = el !== drawer; el.classList.toggle('is-open', el === drawer); });
    if (backdrop) backdrop.hidden = false;
    body.classList.add('drawer-open');
    qs('[data-drawer-close]', drawer)?.focus();
  };
  backdrop?.addEventListener('click', closeDrawer);
  qsa('[data-drawer-close]').forEach(button => button.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', event => {
    if (qs('[data-image-lightbox][open]')) return;
    if (event.key === 'Escape') closeDrawer();
    const active = drawers.find(el => !el.hidden);
    if (event.key !== 'Tab' || !active) return;
    const focusable = qsa('a[href],button:not([disabled]),select,input', active).filter(el => el.offsetParent !== null);
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
  });

  const nav = qs('#MobileNav');
  const menuToggle = qs('[data-menu-toggle]');
  const closeMenu = () => {
    if (!nav || nav.hidden) return;
    nav.hidden = true;
    body.classList.remove('menu-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    menuToggle?.focus();
  };
  menuToggle?.addEventListener('click', () => {
    if (!nav) return;
    nav.hidden = false;
    body.classList.add('menu-open');
    menuToggle.setAttribute('aria-expanded', 'true');
    qs('[data-menu-close]', nav)?.focus();
  });
  qs('[data-menu-close]')?.addEventListener('click', closeMenu);
  const index = qs('[data-activity-index]');
  const indexToggle = qs('[data-index-toggle]');
  const closeIndex = () => {
    if (!index) return;
    index.hidden = true;
    indexToggle?.setAttribute('aria-expanded', 'false');
  };
  indexToggle?.addEventListener('click', () => {
    if (!index) return;
    index.hidden = !index.hidden;
    indexToggle.setAttribute('aria-expanded', String(!index.hidden));
    if (!index.hidden) qs('a', index)?.focus();
  });
  qs('[data-index-close]')?.addEventListener('click', closeIndex);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') { closeMenu(); closeIndex(); }
  });
  qsa('[data-index-image]').forEach(link => {
    const image = qs('[data-index-preview]');
    const files = { trekking: 'azela-hero.webp', walking: 'azela-electron40-black.webp', active: 'azela-running.webp', travel: 'azela-travel.webp', accessories: 'azela-hydration.webp' };
    // Asset URLs are supplied by the image already on the page; this visual swap is optional.
    if (image && files[link.dataset.indexImage]) {
      const source = image.src.replace(/azela-[^/?]+\.webp/, files[link.dataset.indexImage]);
      link.addEventListener('mouseenter', () => { image.src = source; });
      link.addEventListener('focus', () => { image.src = source; });
    }
  });
  qsa('[data-language-select]').forEach(el => el.addEventListener('change', () => el.form?.submit()));

  function cartURL(path) { return root + path; }
  function formatMoney(cents, currency) {
    try { return new Intl.NumberFormat(lang === 'de' ? 'de-DE' : 'en-DE', { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  async function refreshCart(open = false) {
    const response = await fetch(cartURL('cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart');
    const cart = await response.json();
    qsa('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    if (!open || body.dataset.miniCart !== 'true') return;
    const content = qs('[data-mini-cart-content]');
    if (!content) return;
    content.replaceChildren();
    if (!cart.items.length) content.textContent = words.empty;
    cart.items.slice(0, 4).forEach(item => {
      const row = document.createElement('div'); row.className = 'mini-cart__row';
      if (item.image) {
        const img = document.createElement('img'); img.src = item.image; img.alt = item.product_title; img.width = 88; img.height = 88; row.append(img);
      }
      const info = document.createElement('div');
      const title = document.createElement('p'); title.textContent = item.product_title;
      const meta = document.createElement('small'); meta.textContent = item.quantity + ' × ' + formatMoney(item.final_price, cart.currency);
      info.append(title, meta); row.append(info); content.append(row);
    });
    const sum = document.createElement('p'); sum.className = 'mini-cart__total';
    sum.textContent = words.subtotal + ' · ' + formatMoney(cart.total_price, cart.currency);
    content.append(sum);
    openDrawer(qs('[data-mini-cart-drawer]'));
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const submit = qs('[name="add"]', form);
    if (submit?.disabled) return;
    submit?.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;
    let added = false;
    try {
      const response = await fetch(cartURL('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) { const detail = await response.json(); toast(detail.description || words.error); return; }
      added = true;
      await refreshCart(body.dataset.miniCart === 'true');
      if (body.dataset.miniCart !== 'true') toast(words.added);
    } catch (_) {
      toast(added ? words.added : words.error);
    } finally { submit?.removeAttribute('aria-busy'); if (submit) submit.disabled = form.closest('[data-product-state]')?.dataset.variantAvailable === 'false'; }
  });
  qs('[data-mobile-submit]')?.addEventListener('click', () => qs('[data-product-root] [name="add"]')?.click());
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quick-view-open]');
    if (!button || body.dataset.quickView !== 'true') return;
    const template = qs('[data-quick-view-template]', button.closest('[data-product-card]'));
    const content = qs('[data-quick-view-content]');
    if (!template || !content) return;
    content.replaceChildren(template.content.cloneNode(true));
    document.dispatchEvent(new CustomEvent('azela:quick-view', { detail: content }));
    openDrawer(qs('[data-quick-view-drawer]'));
  });

  // Collection forms and pagination share the same URL state.
  let collectionRequest = null;
  const collection = qs('[data-collection-root]');
  const collectionURL = (form, includeSort = true) => {
    const url = new URL(location.href);
    url.search = '';
    const params = new URLSearchParams(new FormData(form));
    if (includeSort) {
      const sort = qs('[data-sort-select]')?.value;
      if (sort) params.set('sort_by', sort);
    }
    params.forEach((value, key) => { if (value !== '') url.searchParams.append(key, value); });
    return url;
  };
  async function loadCollection(url, push = true) {
    const current = qs('[data-collection-root]');
    if (!current) return;
    collectionRequest?.abort();
    collectionRequest = new AbortController();
    current.classList.add('is-loading');
    current.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { signal: collectionRequest.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('collection');
      const html = await response.text();
      const incoming = qs('[data-collection-root]', new DOMParser().parseFromString(html, 'text/html'));
      if (!incoming) throw new Error('collection');
      const update = () => {
        current.replaceWith(incoming);
        motion.refresh(incoming);
        document.dispatchEvent(new CustomEvent('azela:collection', { detail: incoming }));
        if (push) history.pushState({ collection: true }, '', url);
      };
      if (document.startViewTransition && !reduced.matches && body.dataset.pageTransitions === 'true') document.startViewTransition(update);
      else update();
    } catch (error) {
      if (error.name === 'AbortError') return;
      toast(words.error);
      location.assign(url);
    } finally {
      current.classList.remove('is-loading');
      current.removeAttribute('aria-busy');
    }
  }
  if (collection) {
    document.addEventListener('submit', event => {
      if (event.target.id !== 'FacetFiltersForm' && !event.target.matches('[data-sort-form]')) return;
      event.preventDefault();
      const form = event.target.id === 'FacetFiltersForm' ? event.target : qs('#FacetFiltersForm');
      if (form) loadCollection(collectionURL(form));
    });
    document.addEventListener('change', event => {
      if (event.target.matches('[data-sort-select]')) {
        const form = qs('#FacetFiltersForm');
        if (form) loadCollection(collectionURL(form));
      }
    });
    document.addEventListener('click', event => {
      const toggle = event.target.closest('[data-filter-toggle]');
      const close = event.target.closest('[data-filter-close]');
      const panel = qs('[data-filter-panel]');
      if (toggle && panel) {
        const open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        if (open) qs('[data-filter-close]', panel)?.focus();
      }
      if (close && panel) {
        panel.classList.remove('is-open');
        qs('[data-filter-toggle]')?.setAttribute('aria-expanded', 'false');
        qs('[data-filter-toggle]')?.focus();
      }
      const link = event.target.closest('[data-collection-root] .pagination a, [data-collection-root] .filters__reset');
      if (link) { event.preventDefault(); loadCollection(new URL(link.href)); }
    });
    addEventListener('popstate', () => loadCollection(new URL(location.href), false));
  }

  const searchInput = qs('[data-search-input]');
  const suggestions = qs('[data-search-suggestions]');
  let suggestTimer, suggestRequest;
  if (searchInput && suggestions) {
    const close = () => { suggestions.hidden = true; suggestions.replaceChildren(); searchInput.setAttribute('aria-expanded', 'false'); };
    searchInput.addEventListener('input', () => {
      clearTimeout(suggestTimer); suggestRequest?.abort();
      const q = searchInput.value.trim();
      if (q.length < 2) { close(); return; }
      suggestTimer = setTimeout(async () => {
        suggestRequest = new AbortController();
        try {
          const url = new URL(root + 'search/suggest.json', location.origin);
          url.searchParams.set('q', q);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');
          const response = await fetch(url, { signal: suggestRequest.signal });
          if (!response.ok) throw new Error('suggest');
          const data = await response.json();
          suggestions.replaceChildren();
          const products = data.resources?.results?.products || [];
          products.forEach(product => {
            const link = document.createElement('a'); link.href = product.url; link.role = 'option';
            link.textContent = product.title; suggestions.append(link);
          });
          if (!products.length) suggestions.textContent = words.noSuggestions;
          suggestions.hidden = false; searchInput.setAttribute('aria-expanded', 'true');
        } catch (error) { if (error.name !== 'AbortError') close(); }
      }, 220);
    });
    searchInput.addEventListener('keydown', event => {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowDown' && !suggestions.hidden) { event.preventDefault(); qs('a', suggestions)?.focus(); }
    });
    suggestions.addEventListener('keydown', event => {
      const links = qsa('a', suggestions);
      const index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') { event.preventDefault(); (links[index + 1] || links[0])?.focus(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); (links[index - 1] || searchInput)?.focus(); }
      if (event.key === 'Escape') { close(); searchInput.focus(); }
    });
    document.addEventListener('click', event => { if (!event.target.closest('.search-form')) close(); });
  }

  qsa('[data-product-recommendations]').forEach(async container => {
    if (container.innerHTML.trim()) return;
    try {
      const response = await fetch(container.dataset.url);
      const html = await response.text();
      const replacement = qs('[data-product-recommendations]', new DOMParser().parseFromString(html, 'text/html'));
      if (replacement?.innerHTML.trim()) { container.innerHTML = replacement.innerHTML; motion.refresh(container); }
    } catch (_) {}
  });

  const pageIndex = qs('[data-page-index]');
  if (pageIndex) {
    qsa('h2,h3', qs('.page__content') || document).forEach((heading, i) => {
      heading.id ||= 'section-' + (i + 1);
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      pageIndex.append(link);
    });
    if (!pageIndex.children.length) pageIndex.hidden = true;
  }

  // Film panels: the poster carries the frame; the video plays only when motion
  // is allowed and the panel is actually on screen.
  const films = qsa('[data-film]');
  if (films.length) {
    const play = film => {
      const video = qs('video', film);
      if (!video) return;
      const attempt = video.play();
      if (attempt && attempt.then) attempt.then(() => film.classList.add('is-playing')).catch(() => {});
      else film.classList.add('is-playing');
    };
    const pause = film => { const video = qs('video', film); if (video && !video.paused) video.pause(); };
    if (body.dataset.motion === 'off' || reduced.matches) {
      films.forEach(film => { const video = qs('video', film); if (video) { video.removeAttribute('autoplay'); pause(film); } });
    } else if ('IntersectionObserver' in window) {
      const filmObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) play(entry.target); else pause(entry.target);
      }), { threshold: 0.2 });
      films.forEach(film => filmObserver.observe(film));
    } else {
      films.forEach(play);
    }
    reduced.addEventListener?.('change', () => { if (reduced.matches) films.forEach(pause); });
  }

  // Image annotation tour: the dots select which detail the readout shows. The
  // dots stay hidden until this runs, so without JavaScript all details are shown
  // as a plain list rather than being hidden behind an inert control.
  const initTour = tour => {
    if (tour.dataset.annotReady) return;
    const root = tour.closest('.material-story') || tour.parentElement;
    const dots = qsa('.annot__dot', tour);
    const panels = qsa('.annot__panel', root);
    if (!dots.length || dots.length !== panels.length) return;
    tour.dataset.annotReady = '1';
    tour.classList.add('annot--on');
    const count = qs('[data-annot-count]', root);
    const pad = value => String(value).padStart(2, '0');
    let current = 0;
    const show = (next, focus) => {
      current = (next + dots.length) % dots.length;
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.setAttribute('aria-selected', String(active));
        dot.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel, i) => { panel.hidden = i !== current; });
      if (count) count.textContent = pad(current + 1) + ' / ' + pad(dots.length);
      if (focus) dots[current].focus();
    };
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => show(i, false));
      dot.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); show(current + 1, true); }
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); show(current - 1, true); }
        else if (event.key === 'Home') { event.preventDefault(); show(0, true); }
        else if (event.key === 'End') { event.preventDefault(); show(dots.length - 1, true); }
      });
    });
    qs('[data-annot-prev]', root)?.addEventListener('click', () => show(current - 1, false));
    qs('[data-annot-next]', root)?.addEventListener('click', () => show(current + 1, false));
    show(0, false);
  };
  qsa('[data-annotation-tour]').forEach(initTour);
  // The theme editor replaces section markup, so re-init what it hands back.
  document.addEventListener('shopify:section:load', event => qsa('[data-annotation-tour]', event.target).forEach(initTour));

  // Scroll index rail (index template): active band plus reading progress.
  const scrollIndex = qs('[data-scroll-index]');
  if (scrollIndex) {
    const bands = qsa('[data-band]');
    const current = qs('[data-scroll-current]', scrollIndex);
    const total = qs('[data-scroll-total]', scrollIndex);
    const bar = qs('[data-scroll-bar]', scrollIndex);
    const pad = value => String(value).padStart(2, '0');
    if (bands.length && total) total.textContent = pad(bands.length);
    let indexQueued = false;
    const updateIndex = () => {
      indexQueued = false;
      const line = scrollY + innerHeight * 0.42;
      let active = 0;
      bands.forEach((band, i) => { if (band.offsetTop <= line) active = i; });
      if (current) current.textContent = pad(active + 1);
      if (bar) {
        const distance = Math.max(1, document.documentElement.scrollHeight - innerHeight);
        bar.style.setProperty('--scroll-progress', Math.min(100, scrollY / distance * 100) + '%');
      }
    };
    addEventListener('scroll', () => { if (!indexQueued) { indexQueued = true; requestAnimationFrame(updateIndex); } }, { passive: true });
    updateIndex();
  }

  // Featured rail controls.
  const rail = qs('[data-product-rail]');
  if (rail) {
    const step = () => Math.max(240, rail.clientWidth * 0.7);
    const prev = qs('[data-rail-prev]'), next = qs('[data-rail-next]');
    const update = () => { if (prev) prev.disabled = rail.scrollLeft < 2; if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2; };
    prev?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: reduced.matches ? 'auto' : 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: reduced.matches ? 'auto' : 'smooth' }));
    rail.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
  }
})();
